import React from 'react'
import AffordabilityCalc from './partials/Affordability'
import Calculator from './partials/calculator'

type Props = {
    data: Record<string, any>
};

const AffordabilityCalculator = (props: Props) => {
    return (
        <>
            <AffordabilityCalc data={props.data.elements.hero} />

            <Calculator data={props.data.elements['small-print']}/>
        </>
    )
}

export default AffordabilityCalculator